import { Input } from "../../../ui/input"
import { cn } from "../../../ui/utils"
import React, { useState } from "react";
import { Button } from "../../../ui/ot"
import { CircleX, Search, SlidersVertical } from 'lucide-react';
import { Row, Col } from "../../../ui/RowCol";

const SearchOt = ({
    value,
    className,
    type,
    options = [],
    onChange = () => { },
    onSearch = () => { },
    extraIconButton = () => { },
    ...props
},
    ref
) => {
    const [searchValue, setSearchValue] = useState(value || null)
    const [showOptions, setShowOptions] = useState(false);
    const filteredOptions = options.filter(option =>
        String(option).toLowerCase().includes(String(searchValue)?.toLowerCase())
    );

    return (
        <Row>
            <Col>
                <div className="w-full relative">
                    <Input
                        value={searchValue}
                        type={type}
                        className={cn(
                            "flex h-10 w-full rounded-md border border-input bg-background py-2 px-4 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
                            "pl-8",
                            "pr-8",
                            className
                        )}
                        ref={ref}
                        onChange={(e) => {
                            onChange(e.target.value)
                            setSearchValue(e.target.value)
                        }}
                        style={
                            {
                                borderTopRightRadius: '0px',
                                borderBottomRightRadius: '0px'
                            }
                        }
                        onBlur={() => setTimeout(() => setShowOptions(false), 100)} // 延遲隱藏選項
                        onFocus={() => setShowOptions(true)} // 當再次聚焦時顯示選項
                        {...props}
                        list="keywordOptions"
                    />
                    {showOptions && searchValue && filteredOptions.length > 0 && (
                        <ul
                            style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                width: '100%',
                                margin: 0,
                                padding: 0,
                                listStyleType: 'none',
                                backgroundColor: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                maxHeight: '150px',
                                overflowY: 'auto',
                                zIndex: 1000
                            }}
                        >
                            {filteredOptions.map((option, index) => {
                                // Highlight matching text in yellow
                                const parts = String(option).split(new RegExp(`(${searchValue})`, 'gi'));
                                return (
                                    <li
                                        key={index}
                                        onMouseDown={() => {
                                            setSearchValue(option)
                                            onSearch(option)
                                        }}
                                        style={{
                                            padding: '8px',
                                            cursor: 'pointer',
                                            backgroundColor: '#fff'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                    >
                                        {parts.map((part, i) =>
                                            part.toLowerCase() === String(searchValue).toLowerCase() ? (
                                                <span key={i} style={{ backgroundColor: 'yellow' }}>{part}</span>
                                            ) : (
                                                part
                                            )
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                    {
                        extraIconButton()
                    }
                    {(
                        <div className="absolute right-1 top-1/2 transform -translate-y-1/2">
                            <CircleX
                                size={18}
                                style={{
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    console.log("clear")
                                    setSearchValue('')
                                    onChange('')
                                }}
                            />
                            {/* <EndIcon className="text-muted-foreground" size={18} /> */}
                        </div>
                    )}
                </div>
            </Col>
            <Col>
                <Button
                    type="button"
                    style={
                        {
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px'
                        }
                    }
                    onClick={() => {
                        onSearch(searchValue)
                    }}
                >
                    <Search

                    />
                </Button>

            </Col>
        </Row>
    )
}
export default React.forwardRef(SearchOt)